import { useContext } from 'react'

import { AppContext } from '../internal/context'
import type { AppContextType } from '../internal/types'

export default function useAppContext(): AppContextType {
  return useContext(AppContext)
}
